<template>
  <div style="min-width:900px; min-height:520px;">
    <!-- <div style="height:50px; overflow:hidden; min-width:300px;">
      <span style="font-weight:700;font-size:17px;color:#333;margin-left:8px; float:left;">公益项目分布图</span>
      <Select style="width:128px;margin-left:5px;" v-model="type" @on-change="typeChange">
            <Option :value="1">注册用户</Option>
            <Option :value="2">志愿者(审核通过)</Option>
      </Select>
    </div>-->
    <div
      :style="{height:chartHeight,width:chartWidth}"
      :id="id"
      style="float:left;overflow:hidden;margin-left:-50px;margin-top:-10px;z-index:0"
    ></div>
    <!-- <div class="map-table">
      <Row>
        <span>公益项目全国数据分布</span>
      </Row>
      <div v-for="(item, index) in mapData" :key="index" class="map-table-col">
        <span>{{ item.name }}:</span>
        <strong>
          <count-to :end="item.value" count-class="map-count-style" :style="{color:item.color}" />
        </strong>
        <span>个</span>
      </div>
    </div>-->
  </div>
</template>
<script>
import echarts from "echarts";
import china from "echarts/map/json/china";
export default {
  name: "chinaMap",
  props: {
    chartHeight: {
      type: String,
      default() {
        return "485px";
      }
    },
    chartWidth: {
      type: String,
      default() {
        return "75%";
      }
    }
  },
  data() {
    return {
      mapData: [],
      id: this.generatorOnlyId(),
      type: 1
    };
  },
  methods: {
    // 生成图表的唯一ID
    generatorOnlyId() {
      return Math.floor(Math.random() * 10000);
    },

    // 千分化金额
    setMoneyFormat(num) {
      if (Number(num) > 0) {
        let value = typeof num === "number" ? num : Number(num);
        return (value.toFixed(2) + "").replace(
          /\d{1,3}(?=(\d{3})+(\.\d*)?$)/g,
          "$&,"
        );
      } else {
        return num;
      }
    },
    reset() {
      let that = this;
      that.$nextTick(() => {
        // 注册地图
        echarts.registerMap("china", china);
        // 实例化地图
        var chinaMap = echarts.init(document.getElementById(that.id));
        const option = {
          tooltip: {
            trigger: "item",

            formatter: function(params) {
              var res = params.name + "<br/>";

              for (const val of that.mapData) {
                if (val.name === params.name) {
                  res += `收入：${that.setMoneyFormat(
                    val.income_money
                  )} 元<br/>支出：${that.setMoneyFormat(
                    val.value
                  )} 元 <br/>资助数：${val.apply} 个`;
                }
              }
              return res;
            }
            // formatter: "{b}<br/>{c}个"
          },
          toolbox: {
            show: true,
            orient: "vertical",
            left: "right",
            top: "center",
            feature: {}
          },
          visualMap: {
            show: false,
            // x: "left",
            // y: "bottom",
            // splitList: [
            //   { start: 100, label: ">100个" },
            //   { start: 50, end: 100, label: "50~100个" },
            //   { start: 20, end: 50, label: "20~50个" },
            //   { start: 10, end: 20, label: "10~20个" },
            //   { start: 5, end: 10, label: "5~10个" },
            //   { start: 2, end: 5, label: "2~5个" },
            //   { start: 1, end: 1, label: "1个" },
            //   { start: 0, end: 0, label: "无" }
            // ],
            // color: [
            //   "#A7091C",
            //   "#f92721",
            //   "#9f8fff",
            //   "#32d67f",
            //   "#4f7f4a",
            //   "#fa9c53",
            //   "#eeeeee"
            // ],
            min: 0,
            // max: 10000,
            calculable: true,
            inRange: {
              color: ["#fff", "#A7091C"]
            }
          },
          series: [
            {
              name: "",
              type: "map",
              
              mapType: "china", // 自定义扩展图表类型
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    textStyle: {
                      color: "#000",
                      fontSize: 12
                    }
                  }
                },
                emphasis: { label: { show: true }, areaColor: "#C30D23" }
              },
              data: that.mapData
            }
          ]
        };
        // var arryMap = [];
        // var itemsMap = {
        //   name: "南海诸岛",
        //   value: 0
        // };
        // arryMap.push(itemsMap);
        // option.series[0].data = arryMap;
        option.series[0].data.push({
          name: "南海诸岛",
          value: 0,
          itemStyle: {
            normal: {
              opacity: 0,
              label: { show: false },
            },
            emphasis: { opacity: 0, label: { show: false } },
          },
        });
        chinaMap.setOption(option);
      });
    }
  },
  mounted() {
    this.$db.post(this.$db.config.getMapData, {}).then(res => {
      if (res.code == 200) {
        this.mapData = res.data;
      }
    });
    this.reset();
  }
};
</script>





// WEBPACK FOOTER //
// src/components/Home/map.vue